import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import ObjectObservable from "../utils/ObjectObservable";
import NotificationType from "../classes/NotificationType";
import EventBus from "../utils/EventBus";
import MaterialIcons from "../icons/MaterialIcons";
import PageNavigator from "../classes/PageNavigator";
import NotificationUtuils from "../classes/NotificationUtuils";
import UserType from "../classes/UserType";
import Notifications from "../classes/Notifications";
import Query from "../classes/Query";
import NOKUser from "../models/NOKUser";
import MessageDispatch from "../rocket/MessageDispatch";
import NotificatonViewTabChange from "../classes/NotificatonViewTabChange";
import Button from "./Button";
import ListWrapper from "../utils/ListWrapper";
import NotificationsRequest from "../models/NotificationsRequest";
import Notification from "../models/Notification";
import Administrator from "../models/Administrator";
import TextView from "./TextView";
import CollectionUtils from "../utils/CollectionUtils";
import IconView from "./IconView";
import { UsageConstants } from "../rocket/D3ETemplate";
import { BuildContext } from "../classes/BuildContext";

type _Button3OnPressed = (d3eState: _ItemState0) => void;

type _Button4OnPressed = (d3eState: _ItemState1) => void;

export interface NotificationViewProps extends BaseUIProps {
  key?: string;
  user: NOKUser;
  admin: Administrator;
}
/// To store state data for NotificationView
class NotificationViewRefs {
  public itemState0: Map<Notification, _ItemState0> = new Map();
  public itemState1: Map<Notification, _ItemState1> = new Map();
  public forItem0(item: Notification): _ItemState0 {
    let res = this.itemState0.get(item);

    if (res == null) {
      res = new _ItemState0(this, item);

      this.itemState0.set(item, res);
    }

    return res;
  }
  public forItem1(item: Notification): _ItemState1 {
    let res = this.itemState1.get(item);

    if (res == null) {
      res = new _ItemState1(this, item);

      this.itemState1.set(item, res);
    }

    return res;
  }
}

interface Button4WithStateProps extends BaseUIProps {
  key?: string;
  d3eState: _ItemState1;
  _onButton4Handler?: _Button4OnPressed;
}

class Button4State extends ObjectObservable {
  private _disable: boolean = false;
  public _hover: boolean = false;
  public get disable(): boolean {
    return this._disable;
  }
  public setDisable(val: boolean) {
    let isValChanged: boolean = this._disable !== val;

    if (!isValChanged) {
      return;
    }

    this._disable = val;

    this.fire("disable", this);
  }
  public get hover(): boolean {
    return this._hover;
  }
  public setHover(val: boolean) {
    let isValChanged: boolean = this._hover !== val;

    if (!isValChanged) {
      return;
    }

    this._hover = val;

    this.fire("hover", this);
  }
}

class _Button4WithState extends ObservableComponent<Button4WithStateProps> {
  button4FocusNode: ui.FocusNode = new ui.FocusNode();
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: Button4WithStateProps) {
    super(props);

    this.initState();
  }
  public get button4(): Button4State {
    return this.props.d3eState.button4;
  }
  public get d3eState(): _ItemState1 {
    return this.props.d3eState;
  }
  public get _onButton4Handler(): _Button4OnPressed {
    return this.props._onButton4Handler;
  }
  public initState() {
    super.initState();

    this.updateObservable("button4", null, this.button4);

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["button4", "button4.", "button4.hover"], this.rebuild);
  }
  public button4OnEnter(event): void {
    return this.button4.setHover(true);
  }
  public button4OnExit(event): void {
    return this.button4.setHover(false);
  }
  public dispose(): void {
    this.button4.setHover(false);

    super.dispose();
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Container({
      width: 100,
      child: Button({
        padding: this.button4.hover
          ? cStyle.tButtonPrimaryPaddingOnHover
          : cStyle.tButtonPrimaryPaddingOn,
        decoration: this.button4.hover
          ? cStyle.tButtonPrimaryDecorationOnHover
          : cStyle.tButtonPrimaryDecorationOn,
        disable: this.button4.disable,
        onPressed: () => {
          this._onButton4Handler(this.d3eState);
        },
        onFocusChange: (val) => {},
        child: TextView({ data: "View" }),
        onEnter: (event) => {
          this.button4OnEnter(event);
        },
        onExit: (event) => {
          this.button4OnExit(event);
        },
      }),
      className: "xb31 hc",
    });
  }
}
function Button4WithState(props: Button4WithStateProps) {
  return React.createElement(_Button4WithState, props);
}

interface Button3WithStateProps extends BaseUIProps {
  key?: string;
  d3eState: _ItemState0;
  _onButton3Handler?: _Button3OnPressed;
}

class Button3State extends ObjectObservable {
  private _disable: boolean = false;
  public _hover: boolean = false;
  public get disable(): boolean {
    return this._disable;
  }
  public setDisable(val: boolean) {
    let isValChanged: boolean = this._disable !== val;

    if (!isValChanged) {
      return;
    }

    this._disable = val;

    this.fire("disable", this);
  }
  public get hover(): boolean {
    return this._hover;
  }
  public setHover(val: boolean) {
    let isValChanged: boolean = this._hover !== val;

    if (!isValChanged) {
      return;
    }

    this._hover = val;

    this.fire("hover", this);
  }
}

class _Button3WithState extends ObservableComponent<Button3WithStateProps> {
  button3FocusNode: ui.FocusNode = new ui.FocusNode();
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: Button3WithStateProps) {
    super(props);

    this.initState();
  }
  public get button3(): Button3State {
    return this.props.d3eState.button3;
  }
  public get d3eState(): _ItemState0 {
    return this.props.d3eState;
  }
  public get _onButton3Handler(): _Button3OnPressed {
    return this.props._onButton3Handler;
  }
  public initState() {
    super.initState();

    this.updateObservable("button3", null, this.button3);

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["button3", "button3.", "button3.hover"], this.rebuild);
  }
  public button3OnEnter(event): void {
    return this.button3.setHover(true);
  }
  public button3OnExit(event): void {
    return this.button3.setHover(false);
  }
  public dispose(): void {
    this.button3.setHover(false);

    super.dispose();
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Container({
      width: 100,
      child: Button({
        padding: this.button3.hover
          ? cStyle.tButtonPrimaryPaddingOnHover
          : cStyle.tButtonPrimaryPaddingOn,
        decoration: this.button3.hover
          ? cStyle.tButtonPrimaryDecorationOnHover
          : cStyle.tButtonPrimaryDecorationOn,
        disable: this.button3.disable,
        onPressed: () => {
          this._onButton3Handler(this.d3eState);
        },
        onFocusChange: (val) => {},
        child: TextView({ data: "View" }),
        onEnter: (event) => {
          this.button3OnEnter(event);
        },
        onExit: (event) => {
          this.button3OnExit(event);
        },
      }),
      className: "xca9 hc",
    });
  }
}
function Button3WithState(props: Button3WithStateProps) {
  return React.createElement(_Button3WithState, props);
}

class _ItemState0 {
  parent: NotificationViewRefs;
  item: Notification;
  button3: Button3State = new Button3State();
  public constructor(parent, item) {
    this.parent = parent;

    this.item = item;
  }
}

class _ItemState1 {
  parent: NotificationViewRefs;
  item: Notification;
  button4: Button4State = new Button4State();
  public constructor(parent, item) {
    this.parent = parent;

    this.item = item;
  }
}

class _NotificationViewState extends ObservableComponent<NotificationViewProps> {
  static defaultProps = { user: null, admin: null };
  d3eState: NotificationViewRefs = new NotificationViewRefs();
  query: Notifications = null;
  request: NotificationsRequest = null;
  notifications: Array<Notification> = ListWrapper.widget(
    this,
    "notifications"
  );
  unReadNotifications: Array<Notification> = ListWrapper.widget(
    this,
    "unReadNotifications"
  );
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: NotificationViewProps) {
    super(props);

    this.initState();
  }
  public get user(): NOKUser {
    return this.props.user;
  }
  public get admin(): Administrator {
    return this.props.admin;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;

    this.onInit();
  }
  public initListeners(): void {
    this.on(
      [
        "request",
        "request.applyStatus",
        "request.ascending",
        "request.hospital",
        "request.orderBy",
        "request.status",
        "request.user",
      ],
      this.computeQuery
    );

    this.computeQuery();

    this.updateSyncProperty("user", this.props.user);

    this.updateSyncProperty("admin", this.props.admin);

    this.on(["query", "query.items"], this.computeNotifications);

    this.computeNotifications();

    this.on(
      ["notifications", "notifications.viewed"],
      this.computeUnReadNotifications
    );

    this.computeUnReadNotifications();

    this.on(
      [
        "notifications",
        "notifications.createdAt",
        "notifications.description",
        "notifications.title",
        "notifications.type",
        "unReadNotifications",
        "user",
        "user.userType",
      ],
      this.rebuild
    );
  }
  public componentDidUpdate(prevProps: NotificationViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.user !== this.props.user) {
      this.updateObservable("user", prevProps.user, this.props.user);

      this.fire("user", this);
    }

    if (prevProps.admin !== this.props.admin) {
      this.updateObservable("admin", prevProps.admin, this.props.admin);

      this.fire("admin", this);
    }
  }
  public setQuery(val: Notifications): void {
    let isValChanged: boolean = this.query !== val;

    if (!isValChanged) {
      return;
    }

    this.updateObservable("query", this.query, val);

    MessageDispatch.get().dispose(this.query);

    this.query = val;

    this.fire("query", this);
  }
  public computeQuery = async (): Promise<void> => {
    try {
      this.setQuery(
        await Query.get().getNotifications(
          UsageConstants.QUERY_GETNOTIFICATIONS_NOTIFICATIONVIEW_PROPERTIES_QUERY_COMPUTATION,
          this.request,
          { "synchronize": true }
        )
      );
    } catch (exception) {
      console.log(" exception in computeQuery : " + exception.toString());

      this.setQuery(null);
    }
  };
  public setRequest(val: NotificationsRequest): void {
    let isValChanged: boolean = this.request !== val;

    if (!isValChanged) {
      return;
    }

    this.updateObservable("request", this.request, val);

    this.request = val;

    this.fire("request", this);
  }
  public setNotifications(val: Array<Notification>): void {
    let isValChanged: boolean = CollectionUtils.isNotEquals(
      this.notifications,
      val
    );

    if (!isValChanged) {
      return;
    }

    this.updateObservableColl("notifications", this.notifications, val);

    this.notifications.clear();

    this.notifications.addAll(val);

    this.fire("notifications", this);
  }
  public addToNotifications(val: Notification, index: number = -1): void {
    if (index === -1) {
      if (!this.notifications.contains(val)) this.notifications.add(val);
    } else {
      this.notifications.remove(this.notifications.elementAt(index));

      this.notifications.add(val);
    }

    this.fire("notifications", this, val, true);

    this.updateObservable("notifications", null, val);
  }
  public removeFromNotifications(val: Notification): void {
    this.notifications.remove(val);

    this.fire("notifications", this, val, false);

    this.removeObservable("notifications", val);
  }
  public computeNotifications = (): void => {
    try {
      this.setNotifications(Array.from(this.query?.items ?? []));
    } catch (exception) {
      console.log(
        " exception in computeNotifications : " + exception.toString()
      );

      this.setNotifications([]);
    }
  };
  public setUnReadNotifications(val: Array<Notification>): void {
    let isValChanged: boolean = CollectionUtils.isNotEquals(
      this.unReadNotifications,
      val
    );

    if (!isValChanged) {
      return;
    }

    this.updateObservableColl(
      "unReadNotifications",
      this.unReadNotifications,
      val
    );

    this.unReadNotifications.clear();

    this.unReadNotifications.addAll(val);

    this.fire("unReadNotifications", this);
  }
  public addToUnReadNotifications(val: Notification, index: number = -1): void {
    if (index === -1) {
      if (!this.unReadNotifications.contains(val))
        this.unReadNotifications.add(val);
    } else {
      this.unReadNotifications.remove(
        this.unReadNotifications.elementAt(index)
      );

      this.unReadNotifications.add(val);
    }

    this.fire("unReadNotifications", this, val, true);

    this.updateObservable("unReadNotifications", null, val);
  }
  public removeFromUnReadNotifications(val: Notification): void {
    this.unReadNotifications.remove(val);

    this.fire("unReadNotifications", this, val, false);

    this.removeObservable("unReadNotifications", val);
  }
  public computeUnReadNotifications = (): void => {
    try {
      this.setUnReadNotifications(
        Array.from(
          this.notifications.where((element) => !element.viewed).toList()
        )
      );
    } catch (exception) {
      console.log(
        " exception in computeUnReadNotifications : " + exception.toString()
      );

      this.setUnReadNotifications([]);
    }
  };
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      mainAxisSize: ui.MainAxisSize.min,
      children: [
        ui.Row({
          mainAxisAlignment: ui.MainAxisAlignment.spaceBetween,
          children: [
            TextView({
              data:
                "You have  " +
                this.unReadNotifications.length.toString() +
                " new notifications",
              style: new ui.TextStyle({
                fontSize: cStyle.tTextViewHeadlineFourFontSizeOn,
                fontWeight: cStyle.tTextViewHeadlineFourFontWeightOn,
              }),
              key: "0",
            }),
          ],
          className: "x8a1 hc h",
          key: "0",
        }),
        this.user !== null &&
        (this.user.userType === UserType.Admin ||
          this.user.userType === UserType.Staff)
          ? this.notifications
              .where((element) => element.type === NotificationType.ServiceType)
              .expand((item) => [
                ui.Row({
                  mainAxisAlignment: ui.MainAxisAlignment.spaceBetween,
                  children: [
                    IconView({
                      icon: MaterialIcons.notifications,
                      size: 30,
                      color: cStyle.c19,
                      className: "x445",
                      key: "0",
                    }),
                    ui.Column({
                      crossAxisAlignment: ui.CrossAxisAlignment.start,
                      children: [
                        TextView({
                          data: item.title,
                          softWrap: true,
                          style: new ui.TextStyle({
                            fontSize: 14,
                            fontWeight: ui.FontWeight.bold,
                            color: cStyle.c19,
                          }),
                          className: "x98b hc",
                          key: "0",
                        }),
                        TextView({
                          data: item.description,
                          softWrap: true,
                          style: new ui.TextStyle({
                            fontSize: 14,
                            color: cStyle.c19,
                          }),
                          className: "x8b3 hc",
                          key: "1",
                        }),
                        TextView({
                          data: NotificationUtuils.getLastNotificationUsed(
                            item.createdAt
                          ),
                          style: new ui.TextStyle({ color: cStyle.c19 }),
                          className: "xfb5",
                          key: "2",
                        }),
                      ],
                      key: "1",
                    }),
                    Button3WithState({
                      d3eState: this.d3eState.forItem0(item),
                      _onButton3Handler: this.onButton3Handler,
                      key: "2",
                    }),
                  ],
                  className: "x6da hc h",
                  key: item?.ident,
                }),
              ])
          : [],
        this.user !== null && this.user.userType === UserType.Admin
          ? this.notifications
              .where((element) => element.type === NotificationType.InvoiceType)
              .expand((item) => [
                ui.Row({
                  mainAxisAlignment: ui.MainAxisAlignment.spaceBetween,
                  children: [
                    IconView({
                      icon: MaterialIcons.notifications,
                      size: 30,
                      color: cStyle.c19,
                      className: "xd41e",
                      key: "0",
                    }),
                    ui.Column({
                      crossAxisAlignment: ui.CrossAxisAlignment.start,
                      children: [
                        TextView({
                          data: item.title,
                          softWrap: true,
                          style: new ui.TextStyle({
                            fontSize: 14,
                            fontWeight: ui.FontWeight.bold,
                            color: cStyle.c19,
                          }),
                          className: "xca90 hc",
                          key: "0",
                        }),
                        TextView({
                          data: item.description,
                          softWrap: true,
                          style: new ui.TextStyle({
                            fontSize: 14,
                            color: cStyle.c19,
                          }),
                          className: "x11 hc",
                          key: "1",
                        }),
                        TextView({
                          data: NotificationUtuils.getLastNotificationUsed(
                            item.createdAt
                          ),
                          style: new ui.TextStyle({ color: cStyle.c19 }),
                          className: "x527",
                          key: "2",
                        }),
                      ],
                      key: "1",
                    }),
                    Button4WithState({
                      d3eState: this.d3eState.forItem1(item),
                      _onButton4Handler: this.onButton4Handler,
                      key: "2",
                    }),
                  ],
                  className: "xa0e hc h",
                  key: item?.ident,
                }),
              ])
          : [],
      ],
      className: ui.join(this.props.className, "NotificationView x77 hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onInit = (): void => {
    if (this.user !== null) {
      if (this.user.userType === UserType.Admin) {
        this.setRequest(
          new NotificationsRequest({
            orderBy: "sortOrder",
            ascending: false,
            applyStatus: true,
            status: NotificationType.values,
            hospital: this.user.hospital,
          })
        );
      } else {
        this.setRequest(
          new NotificationsRequest({
            orderBy: "sortOrder",
            ascending: false,
            applyStatus: true,
            status: [NotificationType.ServiceType],
            hospital: this.user.hospital,
            user: this.user,
          })
        );
      }
    }
  };
  public onButton3Handler = (d3eState: _ItemState0): void => {
    if (this.user !== null) {
      this.navigator.pushSearchRequestResponseView({
        obj: d3eState.item.request,
        target: "main",
        replace: false,
      });
    }

    EventBus.get().fire(
      new NotificatonViewTabChange({
        tabChangeType: "Requests",
        notification: d3eState.item,
      })
    );

    this.navigator.close();
  };
  public onButton4Handler = (d3eState: _ItemState1): void => {
    this.navigator.pushSystemAdminInvoiceList({
      notification: d3eState.item,
      user: this.user,
      admin: null,
      target: "main",
      replace: false,
    });

    EventBus.get().fire(
      new NotificatonViewTabChange({
        tabChangeType: "Invoices",
        notification: d3eState.item,
      })
    );

    this.navigator.close();
  };
  public dispose(): void {
    MessageDispatch.get().dispose(this.query);

    super.dispose();
  }
  public get navigator(): PageNavigator {
    return PageNavigator.of(this.context);
  }
}
export default function NotificationView(props: NotificationViewProps) {
  return React.createElement(_NotificationViewState, {
    ..._NotificationViewState.defaultProps,
    ...props,
  });
}
